<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-4">
      <h1 class="my-0">Discounts</h1>
      <v-btn color="primary" @click="$router.push({ name: 'website.discount.automatic.create' })" depressed>
        <v-icon>mdi-plus</v-icon> Create
      </v-btn>
    </div>
    <Notification v-if="error" :messages="error" type="error" />
    <v-card class="pa-3">
      <Resource
        :document="document"
        :filter-fields="null"
        :filter-data="filterData"
        :filter-callback="setFilterData"
        :searchable="searchableField"
        :columns="columns"
        :actionItems="items"
        :callback-action="getAction"
        :update-router-callback="getUpdateRouterData"
        :routeName="updateRouteName"
      />
      <div class="d-flex justify-space-between">
        <limit-page :callback="setLimit" />
        <pagination
          :visible="0"
          v-if="!$parent.isLoading && document"
          :length="lengthPage"
          :page.sync="page"
        ></pagination>
      </div>
    </v-card>
    <delete-action :content="ids.length + ' discounts?'" title="Delete discounts" />
  </div>
</template>

<script>
import { discountService } from '@/apis/discount';
import datetime from '@/helpers/datetime';
import Resource from '@/components/Resources';
import resourceListMixin from '@/mixins/resource-list';

export default {
  components: { Resource },
  mixins: [resourceListMixin],
  data() {
    return {
      discounts: [],
      error: null,
      ids: [],
      showDialogDelete: false,
      isLoading: false,
      datetime,
      items: [{ title: 'Delete discounts', action: 'delete' }],
      resourceType: 'discount',
      columns: {
        Selectable: {
          blankLabel: true,
          kind: 'selectable',
          width: 1,
        },
        Code: {
          field: 'discount_code',
          kind: 'view',
        },
        Status: {
          field: 'discount_status',
          kind: 'status',
        },
        Start: {
          field: 'discount_start_date',
          kind: 'date',
          type: 'utc',
        },
        End: {
          field: 'discount_end_date',
          kind: 'date',
          type: 'utc',
        },
      },
      updateRouteName: 'website.discount.automatic.update',
      searchableField: 'title_search',
      sortable: [],
    };
  },
  methods: {
    async submitDelete() {
      try {
        let params = {
          ids: this.ids,
        };
        let data = await discountService.deleteByIds(this.ids);

        await this.getResources();
      } catch (error) {}
      this.showDialogDelete = false;
    },
    getAction(action, ids) {
      if (action.action == 'delete') {
        this.showDialogDelete = true;
        this.ids = ids;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
